module.exports = function() {
  var config, deal_data, ref, t_done, t_page, t_resp, variants;
  config = typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Utils) != null ? ref.getConfigFromDom() : void 0 : void 0;
  if (!(config != null ? config.bucketedExperimentData : void 0)) {
    return;
  }
  if (!(typeof BOOMR !== "undefined" && BOOMR !== null ? BOOMR.getVar : void 0)) {
    return;
  }
  t_resp = BOOMR.getVar('t_resp');
  t_page = BOOMR.getVar('t_page');
  t_done = BOOMR.getVar('t_done');
  variants = config.bucketedExperimentData.experiments;
  deal_data = config.bucketedExperimentData.dealData;
  return OptimizeSuite.TrackingHub.add('deal_page_experiment_performance', {
    deal_data: deal_data,
    t_page: t_page,
    t_done: t_done,
    t_resp: t_resp,
    variants: variants
  });
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9leHBlcmltZW50cy9mcm9udGVuZC9zZW5kRXhwZXJpbWVudFRyYWNreU1lc3NhZ2UuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9leHBlcmltZW50cy9mcm9udGVuZC9zZW5kRXhwZXJpbWVudFRyYWNreU1lc3NhZ2UuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFNBQUE7QUFDZixNQUFBO0VBQUEsTUFBQSwyRkFBdUIsQ0FBRSxnQkFBaEIsQ0FBQTtFQUVULElBQUEsbUJBQWMsTUFBTSxDQUFFLGdDQUF0QjtBQUFBLFdBQUE7O0VBQ0EsSUFBQSxtREFBYyxLQUFLLENBQUUsZ0JBQXJCO0FBQUEsV0FBQTs7RUFFQSxNQUFBLEdBQVMsS0FBSyxDQUFDLE1BQU4sQ0FBYSxRQUFiO0VBQ1QsTUFBQSxHQUFTLEtBQUssQ0FBQyxNQUFOLENBQWEsUUFBYjtFQUNULE1BQUEsR0FBUyxLQUFLLENBQUMsTUFBTixDQUFhLFFBQWI7RUFFVCxRQUFBLEdBQVcsTUFBTSxDQUFDLHNCQUFzQixDQUFDO0VBQ3pDLFNBQUEsR0FBWSxNQUFNLENBQUMsc0JBQXNCLENBQUM7U0FFMUMsYUFBYSxDQUFDLFdBQVcsQ0FBQyxHQUExQixDQUE4QixrQ0FBOUIsRUFBa0U7SUFBQyxXQUFBLFNBQUQ7SUFBWSxRQUFBLE1BQVo7SUFBb0IsUUFBQSxNQUFwQjtJQUE0QixRQUFBLE1BQTVCO0lBQW9DLFVBQUEsUUFBcEM7R0FBbEU7QUFiZSJ9
